import { ProjectsTableColumnField } from "@components/table/projects/projects-table-types";

/** The labels for the columns in the projects table */
export const PROJECTS_TABLE_COLUMN_LABELS: Record<ProjectsTableColumnField, string> = {
  name: "Project Name",
  managerAvatar: "Manager",
  projectManager: "Project Manager",
  accessLevel: "Access Level",
  lastUpdated: "Last Updated",
  created: "Created",
  group: "Group",
  tags: "Tags",
  options: "Options",
  client: "Client",
  size: "Size",
  lastCaptured: "Last Captured",
};
